import React from 'react';

interface Props {
  children: React.ReactNode;
  embedded?: boolean;
}

export const EmbeddedContainer = (props: Props) => {
  const { children, embedded } = props;

  if (embedded) {
    return <div className="mx-auto w-full max-w-md">{children}</div>;
  }

  return <>{children}</>;
};

export default EmbeddedContainer;
